import { render, staticRenderFns } from "./SurgeryConsentList.vue?vue&type=template&id=4123c7b4&scoped=true"
import script from "./SurgeryConsentList.vue?vue&type=script&lang=js"
export * from "./SurgeryConsentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4123c7b4",
  null
  
)

export default component.exports